import React from 'react'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc'
import { SessionExpiredScreen } from '@pushly/aqe/lib/components'
import { SessionState } from '@pushly/aqe'
import { AuthService } from '../../services/auth'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'

export const SessionExpirationScreen: React.FC<{}> = observer(() => {
    const sessionState = Container.get(SessionState)
    const appSvc = useService(AppService)
    const authService = Container.get(AuthService)

    const visible = sessionState.isAuthenticated && (appSvc.sessionExpired || sessionState.sessionExpired)

    return (
        <SessionExpiredScreen
            visible={visible}
            onSignIn={() => authService.logout(true)}
        />
    )
})
